export default __webpack_public_path__ + "static/media/contact-card.2f2e2544.webp";